import { useContext } from "react";
import { GuardarPruebaContext } from "../Contexts/GuardarPrueba/GuardarPrueba";

export default function useGuardarPrueba() {
    const ctx = useContext(GuardarPruebaContext);
    if (!ctx) {
        throw new Error("useGuardarPrueba debe usarse dentro de GuardarPruebaProvider");
    }
    return ctx;
}
